// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Redeem from '../components/Redeem';
import {actions as CheckoutActions} from '../../checkout/duck';
import {actions as ReferralActions} from '../../referrals/duck';
import {actions as AccountActions} from '../../profile/account/duck';
import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
    referreds: state.referral.referreds,
    points: state.referral.availablePoints,
    referralError: state.referral.errorPoints,
    referredsError: state.referral.errorReferreds,
    cardProfiles: state.checkout.cardProfiles,
    isRedeeming: state.referral.isRedeeming,
    redeemError: state.referral.redeemError,
    subscribeError: state.checkout.subscribeError,
    redeemSuccess: state.referral.redeemSuccess,
    isFetchingCardProfiles: state.checkout.isFetchingCardProfiles,
    paymentProviders: state.checkout.paymentProviders,
    subscription: state.tiersList.currentSubscription,
    dueInformation: state.tiersList.dueInformation,
    subscribeSuccess: state.checkout.subscribeSuccess,
    subscriptionSetting: state.accountConfig.subscriptionSetting,
    saveSubscriptionSettingSuccess: state.accountConfig.savingSuccess,
    isSubscribing: state.checkout.isSubscribing,
    isFetchingSubscriptionSetting:
      state.accountConfig.isFetchingSubscriptionSetting,
    isFetchingStore: state.store.isFetchingStore,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {...CheckoutActions, ...ReferralActions, ...AccountActions},
      dispatch
    )
)(Redeem);
